import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignInPage from './pages/SignInPage';
import UploadPage from './pages/UploadPage'; // ✅ add this
import AdminDashboard from './pages/AdminDashboard';
import GenerateUser from './pages/GenerateUser';


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SignInPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/generate" element={<GenerateUser />} />
      </Routes>
    </Router>
  );
}
